import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonConcierge = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 28C16.5523 28 17 27.5523 17 27C17 26.4477 16.5523 26 16 26C15.4477 26 15 26.4477 15 27C15 27.5523 15.4477 28 16 28Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 28C24.5523 28 25 27.5523 25 27C25 26.4477 24.5523 26 24 26C23.4477 26 23 26.4477 23 27C23 27.5523 23.4477 28 24 28Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 27V31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8 21.907L10.975 25.417C10.6781 25.5942 10.4322 25.8453 10.2613 26.1459C10.0905 26.4465 10.0004 26.7862 10 27.132V31H30V27.132C30 26.7866 29.9106 26.4471 29.7404 26.1466C29.5702 25.846 29.3252 25.5947 29.029 25.417L23.2 21.907",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 15V10C15.9069 9.24664 17.9518 8.90582 20 9C22.0482 8.90582 24.0931 9.24664 26 10V15C26 20 23.314 23 20 23C16.686 23 14 20 14 15Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 15C15.9069 14.2466 17.9518 13.9058 20 14C22.0482 13.9058 24.0931 14.2466 26 15",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgPersonConcierge);
export default ForwardRef;
